export default __webpack_public_path__ + "static/media/icon_1.5d8a8942.svg";